import React, { useState, useEffect } from "react";
import Sector from "./Sector";
import Swal from "sweetalert2";

function ItemMesaDividida({
  divisions,
  listaAsientos,
  onClick,
  mesaID,
  listaAsientosRegistrados,
  maxAsientos,
}) {
  const [numSectors, setNumSectors] = useState(divisions);
  const [reserved, setReserved] = useState(false);
  const [selected, setSelected] = useState(false);

  const handleClick = (asiento) => {
    onClick(asiento);
    //console.log(mesaID);
  };
  const sectorAngles = Array.from({ length: numSectors }, (_, i) => {
    const startAngle = (i * 2 * Math.PI) / numSectors;
    const endAngle = ((i + 1) * 2 * Math.PI) / numSectors;
    return { startAngle, endAngle };
  });


  const sectors = sectorAngles.map((angle, i) => {
    return (
      <Sector
        key={i}
        angle={angle}
        index={i}
        listaAsientos={listaAsientos}
        onClick={handleClick}
        mesaID={mesaID}
        reserved={listaAsientosRegistrados.includes(
          mesaID + String.fromCharCode(65 + i)
        )}
        selected={listaAsientos.includes(
          mesaID + `${String.fromCharCode(65 + i)}`
        )}
      />
    );
  });
  return (
    <div>
      <div style={{ textAlign: "center" }}>
        <label
          style={{ fontSize: "30px", fontWeight: "bolder" }}
          htmlFor="numSectors"
        >
          MESA {mesaID}
        </label>
		<p > Seleccionaste  {listaAsientos.length} de { maxAsientos} asientos</p> 

      </div>
      <svg width="250" height="250">
        <g transform={`translate(${125},${125})`}>{sectors}</g>
      </svg>
    </div>
  );
}
export default ItemMesaDividida;
